import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "w-1/4" }
const _hoisted_3 = { class: "text-grey-4 text-sm" }
const _hoisted_4 = { class: "w-3/4" }

import { useSlots } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RowInput',
  props: {
  required: {
    type: Boolean,
    default: false
  },
  label: {
    type: String
  },
  helperText: {
    type: String
  }
},
  setup(__props) {

const props = __props



const slot = useSlots()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: _normalizeClass(`font-semibold text-lg mb-3 ${__props.required ? 'required' : ''}`)
      }, _toDisplayString(__props.label), 3),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.helperText), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(slot)['content'])
        ? _renderSlot(_ctx.$slots, "content", { key: 0 })
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})